export default "__VITE_ASSET__ly03cBl2__"